import { ColorOverlay } from './ColorOverlay';
import { waitForMs } from '../../../utils/async-utils';

export function makeFullScreenFlash(duration: number, color: number, opacity: number): void {
  console.warn('make full screen flash');

  const overlay = new ColorOverlay({
    fillColor: color,
    fillOpacity: opacity,
    blockInteractivity: false,
    anchor: { x: 0, y: 0 },
  });

  overlay.props({
    parent: overlay.pixi.stage,
  });

  overlay.flash(duration);

  waitForMs(duration * 3).then(
    () => {
      overlay.destroy({ children: true });
    },
    () => {},
  );
}
